// Phygital · lightweight event tracker.
// Every clickable action can call trackEvent(name, meta).
// Fire-and-forget POST to /api/phygital/track. Never throws.

import axios from "axios";
import React from "react";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function authHeader() {
  const t = localStorage.getItem("session_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

/** Fire-and-forget event track. Never awaits. */
export function trackEvent(eventName, meta = {}, extra = {}) {
  try {
    const surface = extra.surface || (typeof window !== "undefined" ? window.location.pathname : "");
    const href = extra.href || null;
    axios.post(
      `${API}/phygital/track`,
      { event_name: eventName, meta, href, surface },
      { headers: authHeader() },
    ).catch(() => {});
  } catch { /* ignore */ }
}

/**
 * <TrackedLink to="/me" event="open_dashboard" meta={{from:"admin"}}>...</TrackedLink>
 */
export function TrackedLink({ to, href, event, meta, children, external, className, testid, target, ...rest }) {
  const onClick = () => {
    if (event) trackEvent(event, meta || {}, { href: to || href });
  };
  if (external || href) {
    return (
      <a href={href || to} onClick={onClick} className={className} data-testid={testid}
        target={target || "_blank"} rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} onClick={onClick} className={className} data-testid={testid} {...rest}>
      {children}
    </Link>
  );
}

/** Wraps a click handler with tracking. */
export function useTrackedClick(eventName, meta, handler) {
  return (e) => {
    trackEvent(eventName, meta || {});
    if (handler) handler(e);
  };
}
